import { HttpAuth } from '../../config/Http'
import { changeLoading } from './loading.action'
import { changeNotify } from './notify.action'

export const actionTypes = {
    INDEX: 'METRICS_INDEX',
    CHANGE: 'METRICS_CHANGE',
}

export const change = (payload) => ({
    type: actionTypes.CHANGE,
    payload
})

// INDEX

export const indexResponse = (payload) => ({
    type: actionTypes.INDEX,
    payload
})

export const index = (campaign_id = null, link_id = null, afiliado_id = null, trafic = 'all' , periodo, initial = null, final = null) => dispatch => {
    return HttpAuth.post('/metrics/'+ campaign_id, {
        'link_id' : link_id,
        'afiliado_id': afiliado_id,
        'source' : trafic,
        'periodo' : periodo,
        'initial' : initial,
        'final': final
    })
    .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
    .catch(error => {
        dispatch( changeLoading({ open: false }) )

        if(typeof error.response !== 'undefined') {
            if(error.response.status === 400) {
                if(typeof error.response.data === 'object'){
                    
                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            if(error.response.data.error) {
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }
                    }

                    if(typeof error.response.data.msg !== undefined) {
                        if(typeof error.response.data.msg === 'string'){
                            if(error.response.data.msg) {
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.msg
                                }))
                            }
                        }
                    }
                }
            }
        }
    })
}

export const region = (campaign_id = null, link_id = null, afiliado_id = null , initial = null, final = null) => dispatch => {
    return HttpAuth.post('/metrics/region/'+ campaign_id, {
        'link_id' : link_id,
        'afiliado_id' : afiliado_id,
        'initial' : initial,
        'final': final
    })
    .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
    .catch(error => {
        dispatch( changeLoading({ open: false }) )

        if(typeof error.response !== 'undefined') {
            if(error.response.status === 400) {
                if(typeof error.response.data === 'object'){
                    
                    if(typeof error.response.data.error !== undefined) {
                        if(typeof error.response.data.error === 'string'){
                            dispatch( changeNotify({
                                open: true,
                                class: 'error',
                                msg: error.response.data.error
                            }))
                        }
                    }
                }
            }
        }
    })
}